import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { useInjectReducer } from 'utils/redux-injectors';
import { LoginState } from './types';
import { endpoints, baseQuery } from 'utils/api/endpoints';

export const initialState: LoginState = {
  loading: false,
  error: null,
  user: null,
  isLoggedIn: false,
};

export const api = createApi({
  reducerPath: 'loginApi',
  baseQuery,
  endpoints: build => ({
    login: build.mutation<any, any>({
      query: body => {
        return {
          ...endpoints.login,
          body,
        };
      },
    }),
    forgotPassword: build.mutation<any, any>({
      query: body => {
        return {
          url: endpoints.PROFILE + '/forgot-password',
          method: 'POST',
          body,
        };
      },
    }),
    confirmPasswordReset: build.mutation<any, any>({
      query: body => {
        return {
          url: endpoints.PROFILE + '/confirm-password-reset',
          method: 'GET',
          params: body,
        };
      },
    }),
    resetPassword: build.mutation<any, any>({
      query: body => {
        return {
          url: endpoints.PROFILE + '/reset-password',
          method: 'POST',
          body,
        };
      },
    }),
    verify2fa: build.mutation<any, any>({
      query: body => {
        return {
          url: endpoints.PROFILE + '/verify-2fa',
          method: 'POST',
          body,
        };
      },
    }),
    enable2fa: build.mutation<any, any>({
      query: body => {
        return {
          url: endpoints.PROFILE + '/microsoft-2fa/enable',
          method: 'POST',
          body,
        };
      },
    }),
    verifyBackupCode: build.mutation<any, any>({
      query: body => {
        return {
          url: endpoints.PROFILE + '/verify-backup-code',
          method: 'POST',
          body,
        };
      },
    }),
  }),
});

export const useLoginSlice = () => {
  useInjectReducer({ key: api.reducerPath, reducer: api.reducer });
  return {
    useLoginMutation: api.useLoginMutation,
    useForgotPasswordMutation: api.useForgotPasswordMutation,
    useConfirmPasswordResetMutation: api.useConfirmPasswordResetMutation,
    useResetPasswordMutation: api.useResetPasswordMutation,
    useVerify2FAMutation: api.useVerify2faMutation,
    useEnable2FAMutation: api.useEnable2faMutation,
    useVerifyBackupCodeMutation: api.useVerifyBackupCodeMutation,
  };
};
